import { render, staticRenderFns } from "./None.vue?vue&type=template&id=1aa0e85b&scoped=true"
import script from "./None.vue?vue&type=script&lang=js"
export * from "./None.vue?vue&type=script&lang=js"
import style0 from "./None.vue?vue&type=style&index=0&id=1aa0e85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0e85b",
  null
  
)

export default component.exports